import { render, staticRenderFns } from "./ModalPurchaseOrders.vue?vue&type=template&id=134a0cbc"
import script from "./ModalPurchaseOrders.vue?vue&type=script&lang=js"
export * from "./ModalPurchaseOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports